// WHY (#1496): canonical destination text for list/header/card surfaces.
//   `route.to` is a denormalised search mirror that can drift from the
//   canonical `destinations[]` when destinations are edited post-creation.
//   STANDARD and SIMPLE requests must read `destinations[]` to stay
//   consistent with the per-city carriers section. CONTAINER requests
//   carry no `destinations` and keep reading `deliveryAddress`.
//
// INVARIANT: preserves `r.destinations` wire array order — do NOT sort
//   here. Backend #1497 owns stable sort order (sortOrder ASC, arrivalCityId ASC).
import type { RequestView } from './types.js';

/**
 * @aiPurpose Return the canonical destination display string for a request.
 *   CONTAINER → `deliveryAddress` (or '—'). STANDARD/SIMPLE → joined
 *   arrival city names from `destinations[]` in wire order.
 * @aiInvariant Does not sort or mutate the input array. Wire order is
 *   authoritative and must match CarriersTab rendering.
 */
export function formatRequestDestination(
  request: Pick<RequestView, 'kind' | 'deliveryAddress' | 'destinations'>,
  opts: { short: boolean },
): string {
  if (request.kind === 'CONTAINER') {
    return request.deliveryAddress || '—';
  }
  if (request.destinations.length === 0) {
    return '—';
  }
  return request.destinations
    .map((d) => (opts.short ? d.arrivalCity.shortName : d.arrivalCity.name))
    .join(', ');
}
